<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <div v-if="$store.getters.isOffline" >
          <b-alert variant="danger" show><b>No Connection detected.</b> You are offline right now, please check your internet connection.</b-alert>
        </div>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
import {
  Header as AppHeader,
  Sidebar, Aside as AppAside,
  Footer as AppFooter
} from '../components/'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter
  },
  computed: {
    name () {
      return this.$route.name
    },
    nav () {
      return nav.items // .filter(x => x.moduleId == this.$store.getters.getChosenModule) // eslint-disable-line
    },
    isOtherPage () {
      let isPage = this.$route.name.indexOf('Page') > -1
      // if (isPage) {
      //   document.body.classList.add('sidebar-hidden')
      // } else {
      //   document.body.classList.remove('sidebar-hidden')
      // }
      // document.body.classList.remove('sidebar-mobile-show')
      return isPage
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue